import consola from 'consola';
import * as config from './config';
import ConsoleLogReporter from './reporters/consoleReporter';
import BureaucratLogReporter from './reporters/bureaucratReporter';

// level 4 is debug: https://github.com/unjs/consola/blob/master/src/types.js
consola.level = 4;

const getLoggerOpts = (label) => ({
  label,
  service: 'diplomat',
  deployment: config.DEPLOYMENT,
});

export const getConsoleLogger = (moduleName) =>
  consola.create({
    reporters: [new ConsoleLogReporter(getLoggerOpts(moduleName))],
  });

export const getLogger = (moduleName) => {
  const reporters = [];

  if (config.DEPLOYMENT_TYPE !== 'prod') {
    reporters.push(new ConsoleLogReporter(getLoggerOpts(moduleName)));
  }

  if (config.ENABLE_LOG_BOOK_KEEPING) {
    reporters.push(new BureaucratLogReporter(getLoggerOpts(moduleName)));
  }

  return consola.create({ reporters });
};
